import BlankBlock from "./config/blank";
import ButtonBlock from "./config/button";
import CardBlock from "./config/card-block";
import HeadingBlock from "./config/heading";
import { sanitizeHtml, sanitizeUrl } from "./config/sanitize";

import LogosBlock from "./config/logos";
import RichTextBlock from "./config/rich-text";
import FlexBlock from "./config/flex";
import ImageBlock from "./config/image";
import GridBlock from "./config/grid";
import TextBlock from "./config/text";
import YouTubeBlock from "./config/youtube";


export const config = {
  components: {
  HeadingBlock,

    TextBlock,
    ButtonBlock,
    CardBlock,
    RichTextBlock,
    BlankBlock,

    TwoColumnsBlock: {
      fields: {
        leftColumn: { type: "slot" },
        rightColumn: { type: "slot" },
      },
      render: ({ leftColumn: LeftColumn, rightColumn: RightColumn }) => (
        <div className="grid grid-cols-2 gap-6">
          <LeftColumn />
          <RightColumn />
        </div>
      ),
    },
    LogosBlock,
    YouTubeBlock,
    GridBlock,
    FlexBlock,
    ImageBlock,

    ContentBlock: {
      fields: {
        title: { type: "text", label: "Post title" },
        excerpt: { type: "textarea", label: "Post excerpt" },
        image: { type: "text", label: "Image URL" },
        body: {
          type: "richtext",
          options: {
            heading: { levels: [1, 2] },
          },
        },
      },
      render: ({ title, excerpt, image, body }) => (
        <div className="p-4 border rounded">
          {image && <img src={sanitizeUrl(image)} alt="" className="mb-2" />}
          {title && <h3 className="font-bold mb-1">{title}</h3>}
          {excerpt && <p>{excerpt}</p>}
           {body && (
        typeof body === "string" ? (
          <div
            className="mt-2 prose max-w-none"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(body) }}
          />
        ) : (
          <div className="mt-2 prose max-w-none">
            {body}
          </div>
        )
      )}
        </div>
      ),
    },
  },
};
